import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { StateModel } from "../../models/StateModel";
import ProjectService from "../../services/ProjectService";
import StateSlice from "../slices/StateSlice";
import { RootState } from "../store/index";

export const StateActions = StateSlice.actions;
export const getStatesForCountry = (
  countryCode: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: StateModel[] = await ProjectService.getStatesForCountry(
      countryCode
    );
    dispatch(StateActions.setStates(response));
  };
};

export const getAllStates = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(StateActions.setIsStatesFetching(true));
    const response: StateModel[] = await ProjectService.getAllStates();
    dispatch(StateActions.setStates(response));
    dispatch(StateActions.setIsStatesFetching(false));
  };
};

export const resetStates = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(StateActions.resetStates());
  };
};
